import classes from './MismatchedDataDetails.module.css'
import PatientDetailsHeader from '../../../../patient/page/PatientDetailsHeader'
import Card from '../../../../common/Card'
import PatientInfoMismatched from './PatientInfoMismatched'
import { useSelector } from 'react-redux'


export default function MismatchedDataDetailsInner({data}) {
    const activeCase = useSelector(state => state.case.activeCase)

    return <>
        {activeCase && <div className={classes.police_report_details}>
            <PatientDetailsHeader noEdit={true} />
            <div className={classes.police_report_details_inner}>                

                <Card>
                    <div className={classes.police_report_details_inner_wrapper}>           

                        <div className={classes.group_header}>
                            <div className={classes.group_header_cell}>
                                
                            </div>
                            <div className={classes.group_header_cell}>
                                <strong>Drivers License</strong>
                            </div>
                            <div className={classes.status}>
                            </div>
                            <div className={classes.group_header_cell}>
                                <strong>Patient Info</strong>
                            </div>
                        </div>             

                        <PatientInfoMismatched classes={classes} activeCase={activeCase}/>

                    </div>
                </Card>
                
            </div>
        </div>}
    </>
}